import * as React from "react";
import { Menu } from "@coinlist/frontend-ui-lib"
require("@coinlist/frontend-ui-lib/dist/style.css");

export default function HeaderMenu(props) {
    return (
        <Menu onlyEntities={props.onlyEntities} csrfToken={document.querySelector("meta[name='csrf-token']").getAttribute("content") as string} setEntityPath={props.setEntityPath} canCreatePersonEntities={props.canCreatePersonEntities} extraAccounts={props.extraAccounts} locale={props.locale} user={props.user} isBusiness={props.isBusiness} />
    );
}
